import TermsOfService from 'components/TermsOfService';
import { Component } from 'react';
import { hasErrors, validateUserForm } from '../../../utils/UserFormHelper';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import FormButton from '../FormButton';
import * as formStyles from '../styles/styles.module.scss';
import OutlinedTextField from '../textFields/OutlinedTextField';
import Wrapper from '../Wrapper';
import CustomProvider from 'components/CustomProvider';
import { FormattedMessage } from 'react-intl';

class PasswordResetForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      confirmPassword: '',
      errors: {
        password: '',
        confirmPassword: ''
      },
      serverError: null,
      submitting: false
    };
  }

  // validation
  validateConfirmPassword(value) {
    if (this.state.password === value) {
      return {};
    }

    return { confirmPassword: <FormattedMessage defaultMessage="Passwords don't match" /> };
  }

  failedFormValidation = () => {
    let validationErrors = { ...this.state.errors };
    let validation;
    for (const name in this.state.errors) {
      validation =
        name === 'confirmPassword'
          ? { errors: this.validateConfirmPassword(this.state.confirmPassword) }
          : validateUserForm(name, this.state[name], validationErrors);

      validationErrors = { ...validationErrors, ...validation.errors };
    }

    this.setState({ errors: validationErrors });
    return hasErrors(validationErrors);
  };

  // handlers
  handleSuccess = res => {
    window.location.href = LanguageSupportUtil.wrapUrlSafe(res.redirectUrl, this.props.locale);
  };

  handleError = err => {
    if (!err.responseJSON || !err.responseJSON.errors) {
      this.setState({ submitting: false });
      return;
    }
    const serverError = err.responseJSON.errors.join(', ');
    this.setState({ serverError, submitting: false });
  };

  handleComplete = () => {};

  handleChange = e => {
    const { name, value } = e.target;
    const errors = validateUserForm(name, value, { ...this.state.errors });

    if (name === 'confirmPassword') {
      errors.errors = { ...errors.errors, ...this.validateConfirmPassword(value) };
    }

    this.setState({ ...errors, [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    if (this.failedFormValidation()) {
      this.setState({ submitting: false });
      return;
    }

    this.setState({ submitting: true });
    const headers = this.props.locale ? { 'X-Language-Locale': this.props.locale } : {};
    const params = {
      [this.props.resourceName]: {
        password: this.state.password,
        reset_password_token: this.props.resetPasswordToken
      }
    };

    ServerCommunicationUtil.putApiEndpoint(this.props.resetPasswordUrl, params, this.handleSuccess, this.handleError, this.handleComplete, headers);
  };

  renderPasswordInput() {
    return (
      <div className={formStyles.inputItem}>
        <OutlinedTextField
          changeHandler={this.handleChange}
          enterKeyHandler={this.handleSubmit}
          errorMessage={this.state.errors.password}
          label={<FormattedMessage defaultMessage="Password" />}
          name="password"
          type="password"
          value={this.state.password}
        />
      </div>
    );
  }

  renderConfirmPassword() {
    return (
      <div className={formStyles.inputItem}>
        <OutlinedTextField
          changeHandler={this.handleChange}
          enterKeyHandler={this.handleSubmit}
          errorMessage={this.state.errors.confirmPassword}
          label={<FormattedMessage defaultMessage="Confirm Password" />}
          name="confirmPassword"
          type="password"
          value={this.state.confirmPassword}
        />
      </div>
    );
  }

  renderErrorsAndSubmit() {
    return (
      <div className={`${formStyles.inputItem}`}>
        <div className={formStyles.serverError}>{this.state.serverError}</div>
        <FormButton disabled={this.state.submitting} value={<FormattedMessage defaultMessage="Submit" />} />
      </div>
    );
  }

  render() {
    return (
      <CustomProvider>
        <Wrapper
          foot={<TermsOfService />}
          showStepText
          text={{
            headText: <FormattedMessage defaultMessage="Reset your password" />,
            stepText: <FormattedMessage defaultMessage="Enter your new password below. It must be at least 6 characters long" />
          }}
        >
          <form onSubmit={this.handleSubmit}>
            {this.renderPasswordInput()}
            {this.renderConfirmPassword()}
            {this.renderErrorsAndSubmit()}
          </form>
        </Wrapper>
      </CustomProvider>
    );
  }
}

export default PasswordResetForm;
